import { DwQueryRequest } from '@views/CustomDashboards/types';
import { createExpressionArrayFromFilters } from '../utils';
import { FilterContext } from './utils';

// All agent list
export const getAllAgents = {
  select: {
    dims: [
      {
        name: 'uber_z_agent.name',
        alias: 'name',
      },
      {
        name: 'uber_z_agent.x_description',
        alias: 'description',
      },
      {
        name: 'uber_z_agent._key',
        alias: 'agent_id',
      },
      {
        name: 'uber_z_agent.x_category',
        alias: 'category',
      },
    ],
  },
  groupBy: ['uber_z_agent.name', 'uber_z_agent.x_description', 'uber_z_agent._key'],
  filter: {
    and: {
      operands: [
        {
          expression: {
            fieldName: 'uber_z_agent.x_isenabled',
            stringCondition: {
              equals: 'true',
            },
          },
        },
        {
          expression: {
            fieldName: 'uber_z_agent.x_developmentstate',
            stringCondition: {
              equals: 'Production',
            },
          },
        },
      ],
    },
  },
  projectionId: {
    name: 'uber_z_agent',
    builtIn: true,
  },
} as DwQueryRequest;

// Alerts count
export const getTotalAlertsCountByAgents = (filterContext: FilterContext) =>
  ({
    select: {
      metrics: [
        {
          name: 'count_distinct(uber_z_agent_execution_inputs.alert.source_key)',
          alias: 'cnt',
        },
      ],
    },
    filter: {
      and: {
        operands: [
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.x_input_type',
              stringCondition: {
                equals: 'Alert',
              },
            },
          },
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.z_agent_execution.z_agent.x_isenabled',
              stringCondition: {
                equals: 'true',
              },
            },
          },
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.z_agent_execution.z_agent.x_developmentstate',
              stringCondition: {
                equals: 'Production',
              },
            },
          },
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.first_seen',
              dateCondition: { between: { values: filterContext.dateRange } },
            },
          },
          ...createExpressionArrayFromFilters(filterContext),
        ],
      },
    },
    projectionId: {
      name: 'uber_z_agent_execution_inputs',
      builtIn: true,
    },
  }) as DwQueryRequest;

// total alerts by agents
export const getAlertsByAgent = (filterContext: FilterContext) =>
  ({
    select: {
      dims: [
        {
          name: 'uber_z_agent_execution_inputs.z_agent_execution.z_agent.name',
          alias: 'name',
        },
        {
          name: 'uber_z_agent.x_description',
          alias: 'description',
        },
        {
          name: 'uber_z_agent._key',
          alias: 'agent_id',
        },
        {
          name: 'uber_z_agent.x_category',
          alias: 'category',
        },
        {
          name: 'uber_z_agent_execution.x_outcome',
          alias: 'outcome',
        },
      ],
      metrics: [
        {
          name: 'count_distinct(uber_z_agent_execution_inputs.alert.source_key)',
          alias: 'cnt',
        },
      ],
    },
    groupBy: ['uber_z_agent.x_category'],
    filter: {
      and: {
        operands: [
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.x_input_type',
              stringCondition: {
                equals: 'Alert',
              },
            },
          },
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.z_agent_execution.z_agent.x_isenabled',
              stringCondition: {
                equals: 'true',
              },
            },
          },
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.z_agent_execution.z_agent.x_developmentstate',
              stringCondition: {
                equals: 'Production',
              },
            },
          },
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.first_seen',
              dateCondition: { between: { values: filterContext.dateRange } },
            },
          },
          ...createExpressionArrayFromFilters(filterContext),
        ],
      },
    },
    projectionId: {
      name: 'uber_z_agent_execution_inputs',
      builtIn: true,
    },
  }) as DwQueryRequest;

// alert count resolution under 5 min
export const getAlertCountUnder5Mins = (filterContext: FilterContext) =>
  ({
    select: {
      metrics: [
        {
          name: 'count_distinct(uber_z_agent_execution_inputs.alert.source_key)',
          alias: 'cnt',
        },
      ],
    },
    filter: {
      and: {
        operands: [
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.x_input_type',
              stringCondition: {
                equals: 'Alert',
              },
            },
          },
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.z_agent_execution.z_agent.x_isenabled',
              stringCondition: {
                equals: 'true',
              },
            },
          },
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.z_agent_execution.z_agent.x_developmentstate',
              stringCondition: {
                equals: 'Production',
              },
            },
          },
          {
            expression: {
              fieldName: 'uber_z_agent_execution.x_latency',
              numberCondition: {
                lt: 30000,
              },
            },
          },
          {
            expression: {
              fieldName: 'uber_z_agent_execution_inputs.first_seen',
              dateCondition: { between: { values: filterContext.dateRange } },
            },
          },
          ...createExpressionArrayFromFilters(filterContext),
        ],
      },
    },
    projectionId: {
      name: 'uber_z_agent_execution_inputs',
      builtIn: true,
    },
  }) as DwQueryRequest;
